module.exports = __webpack_public_path__ + "static/ZoomInfo-b84fc6d43b7447312fbd35cc8cc8b457.jpg";